module.exports = __webpack_public_path__ + "img/ico_5.8df642dc.jpg";